import type React from 'react'
import type { ReactNode } from 'react'

import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { AccordionDetails, AccordionSummary } from '@mui/material'

import { AccordionStyled } from './styles'

export interface AccordionProps {
  summaryContent?: ReactNode
  children?: ReactNode
  height?: number
  width?: string
  defaultExpanded?: boolean
}

export const Accordion: React.FC<AccordionProps> = ({
  summaryContent,
  defaultExpanded = true,
  children,
  height = 80,
  width = '100%',
}) => {
  return (
    <AccordionStyled defaultExpanded={defaultExpanded} height={height} width={width}>
      <AccordionSummary
        data-testid="summary"
        expandIcon={<ExpandMoreIcon data-testid="expand-icon" />}
        id="AccordionTitle"
      >
        {summaryContent}
      </AccordionSummary>
      <AccordionDetails data-testid="details">{children}</AccordionDetails>
    </AccordionStyled>
  )
}
